/** Jedna instancja ładowania skryptu youtube.com/iframe_api dla całej aplikacji. */
let ytIframeApiPromise: Promise<void> | null = null;

export function ensureYoutubeIframeApi(): Promise<void> {
  ytIframeApiPromise ??= new Promise((resolve) => {
    const w = window as unknown as {
      YT?: { Player: unknown };
      onYouTubeIframeAPIReady?: () => void;
    };
    if (w.YT?.Player) {
      resolve();
      return;
    }
    const prev = w.onYouTubeIframeAPIReady;
    w.onYouTubeIframeAPIReady = (): void => {
      prev?.();
      resolve();
    };
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }
  });
  return ytIframeApiPromise;
}
